import React, { useEffect,useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from '../helpers/withRouter';
import classNames from "classnames";
import { connect } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";

// Components
import Header from "./Header";
import Footer from "./Footer";
import Spinner from "./Spinner";

const Wrapper = (props) => {
  const location = useLocation();

  const [isAdmin, setIsAdmin] = useState(false);
  const [hasSpinner, setHasSpinner] = useState(false);

  const customColors = {
    primary: "black",
    secondary: "#dd3333"
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    let isAdmin = pathname.includes("/admin/");
    if(isAdmin) {
      setIsAdmin(true)
      if(pathname.includes("/admin/signin")) {
        document.body.classList.remove("s-admin");
      }else {
        document.body.classList.add("s-admin");
      }
    }
  }, []);

  useEffect(() => {
    let root = document.documentElement;
    root.style.setProperty("--primary-color", customColors.primary);
    root.style.setProperty("--secondary-color", customColors.secondary);
  }, [customColors]);

  return (
    <main>
      {
        hasSpinner && <Spinner />
      }
      <Header url_home={"/"} history={props.history} location={location} key={location.pathname} />
       <Outlet />  
      <Footer policy_link={props.survey.policy_link} disclaimer_link={props.survey.disclaimer_link} />
    </main>
  );

}

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    client: state.client,
    survey: state.survey,
  };
};


export default withRouter(connect(mapStateToProps, null)(Wrapper));

